import React from 'react'
import './TrainingStyles.css'

import { Link } from 'react-router-dom'

import Pod from '../assets/pod.jpg'
import Moon from '../assets/moon.jpg'
import Pod2 from '../assets/pod2.jpg'
import Moon2 from '../assets/moon2.jpg'

const Training = () => {
    return (
        <div className='training'>
            <div className='left'>
                <h1>The Africa Mining Summit Investment</h1>
                <p>Our mission is to ignite a mining revolution in Africa. By uniting industry leaders, fostering collaboration, and driving innovation, we aim to create a sustainable future where African mining thrives and benefits all.</p>
                <Link to='/contact'><button className='btn'>Register Now</button></Link>
            </div>
            <div className='right'>
                <div className='img-container'>
                    <div className='image-stack top'>
                        <img src={Moon} className='img' alt='' />
                    </div>
                    <div className='image-stack bottom'>
                        <img src={Pod} className='img' alt='' />
                    </div>
                </div>
            </div>
            <div className='t_right'>
                <div className='img-container'>
                    <div className='image-stack top'>
                        <img src={Moon2} className='img' alt='' />
                    </div>
                    <div className='image-stack bottom'>
                        <img src={Pod2} className='img' alt='' />
                    </div>
                </div>
            </div>
            <div className='t_left'>
                <h1>Our Mission</h1>
                <p>we thrive to create a transformative space where industry thought leaders come together to drive positive change. By fostering collaboration and innovation, we aim to lift the African mining sector into a future defined by sustainable practices and unprecedented growth.</p>
                {/* <Link to='/contact'><button className='btn'>Contact</button></Link> */}
            </div>
        </div>

    )
}

export default Training
